import { createContext, useContext } from "react";

/**
 * The negotiation a revision continues, as the reader may read it (#5567).
 *
 * A revision of hired work opens on terms both parties already agreed, and the history of those terms
 * is the event stream of the negotiation that agreed them — not of this one. Each field's history
 * popover shows that earlier history below its own, so a field that has not changed in this revision
 * still says where its value came from. The page resolves the earlier negotiation once; every
 * history control on it reads it from here, rather than having it threaded through each tab.
 *
 * `viewerScope` is the cache scope the page read the earlier envelope under, which is never the
 * viewer's live one: the earlier negotiation must not land in the store as the negotiation being
 * edited, or have this page's pending changes previewed against it.
 *
 * Undefined for a proposal that revises nothing, and for a reader the earlier negotiation does not
 * admit — their read of it is refused, and they see no earlier history, which is what they would see
 * if there were none.
 */
export type ProposalCarriedOverNegotiation = {
  negotiationId: string;
  viewerScope: string;
};

export const ProposalCarriedOverNegotiationContext = createContext<ProposalCarriedOverNegotiation | undefined>(
  undefined,
);

export function useProposalCarriedOverNegotiation(): ProposalCarriedOverNegotiation | undefined {
  return useContext(ProposalCarriedOverNegotiationContext);
}
